import React from 'react';
import { useOrderOperations } from '../hooks/useOrderOperations';

export const OrderItem = React.memo(({ order }) => {
  const { calculateOrderMetrics, calculateOrderBreakdown } = useOrderOperations();
  const metrics = calculateOrderMetrics(order);
  const breakdown = calculateOrderBreakdown(order);

  const imageUrl = order.images?.[0]?.url?.trim();
  const isPlane = (order.specification || "").toUpperCase() === "PLANE";

  return (
    <div className="order-item">
      <div className="orderGroupBadge">
        <div className={`item-status-badge status-${(order.orderStatus || 'assigned').toLowerCase()}`}>
          {order.orderStatus || "Assigned"}
        </div>
      </div>

      <div className="order-item-header">
        <div className="item-image">
          {imageUrl ? (
            <img src={imageUrl} alt={order.productName || 'Product'} loading="lazy" />
          ) : (
            <div className="image-placeholder">No Image</div>
          )}
        </div>
        <div className="item-head-info">
          <h4 className="item-name">{order.productName || 'Unnamed Product'}</h4>
          <span className="purity">
            {order.category || 'N/A'} {order.purity ? `· Purity ${order.purity}%` : ''}
          </span>
          <span className="weight">
            <span>{metrics.approx ? "~" : ""}gross {metrics.grossWt.toFixed(3)}g · {metrics.approx ? "~" : ""}net <span className='value-amount'>{metrics.netWt.toFixed(3)}g</span></span>
            <span>Qty: {metrics.totalSets}</span>
            <span>{metrics.approx ? "~" : ""}fine <span className='value-amount'>{metrics.fineWeight.toFixed(3)}g</span></span>
          </span>
          <span className="weight-amount">
            Amount: <span className='value-amount'>₹{metrics.totalAmount.toFixed(2)}</span>
          </span>
        </div>
      </div>

      <div className="order-body">
        {breakdown.hasSizes && (
          <div className="size-breakdown">
            {!breakdown.locked && (
              <div className="approx-badge">Prox ~ approximate</div>
            )}
            <div className="size-table-scroll">
              <div
                className="size-table"
                style={{ "--cols": breakdown.showSpecWt ? "minmax(54px, 1.1fr) repeat(4, minmax(50px, 1fr)) minmax(60px, 1fr)" : "minmax(54px, 1.1fr) repeat(3, minmax(50px, 1fr)) minmax(60px, 1fr)" }}
              >
                <div className="sizes-row size-head">
                  <span>Size</span>
                  <span>Qty</span>
                  <span>Gross</span>
                  <span>Net</span>
                  {breakdown.showSpecWt && <span>Spec Wt</span>}
                  <span>Fine Wt</span>
                </div>
                {breakdown.rows.map((r) => (
                  <div className="sizes-row" key={r.size}>
                    <span>{r.size}</span>
                    <span>{r.qty}</span>
                    <span>{`${r.approx ? "~" : ""}${r.gross.toFixed(3)}g`}</span>
                    <span>{`${r.approx ? "~" : ""}${r.net.toFixed(3)}g`}</span>
                    {breakdown.showSpecWt && (
                      <span>{`${r.approx ? "~" : ""}${r.spec.toFixed(3)}g`}</span>
                    )}
                    <span className='value-amount'>{`${r.approx ? "~" : ""}${r.fine.toFixed(3)}g`}</span>
                  </div>
                ))}
                <div className="sizes-row size-totals-row">
                  <span>Total</span>
                  <span>{breakdown.totals.totalQty}</span>
                  <span>{`${breakdown.approx ? "~" : ""}${breakdown.totals.totalGross.toFixed(3)}g`}</span>
                  <span>{`${breakdown.approx ? "~" : ""}${breakdown.totals.totalNet.toFixed(3)}g`}</span>
                  {breakdown.showSpecWt && (
                    <span>{`${breakdown.approx ? "~" : ""}${breakdown.totals.totalSpec.toFixed(3)}g`}</span>
                  )}
                  <span className='value-amount'>{`${breakdown.approx ? "~" : ""} ${breakdown.totals.totalFine.toFixed(3)}g`}</span>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="order-side-totals">
          <span className="side-total">Gross: {metrics.grossWt.toFixed(3)}g</span>
          <span className="side-total">Net: {metrics.netWt.toFixed(3)}g</span>
          {!isPlane && (
            <span className="side-total">Spec: {metrics.specWt.toFixed(3)}g</span>
          )}
          <span className="side-total">Fine Wt: <span className='value-amount'>{metrics.fineWeight.toFixed(3)}g</span></span>
          <span className="side-total">Qty: {metrics.totalSets}</span>
          <span className="side-total ">MC: <span className='value-amount'>₹{metrics.totalMc.toFixed(2)}</span></span>
          <span className="side-total">Stamp: <span className='value-amount'>₹{metrics.stampCost.toFixed(2)}</span></span>
          <span className="side-total total-amount-chip">Amount: <span className='value-amount'>₹{metrics.totalAmount.toFixed(2)}</span></span>
        </div>
      </div>
    </div>
  );
});